import React, { Component } from "react";
import "../../assets/css/product.css";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {
  Row,
  Col,
  InputGroup,
  InputGroupAddon,
  Input,
  Button,
  Tooltip
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlusCircle,
  faMinusCircle,
  faShoppingCart
} from "@fortawesome/free-solid-svg-icons";
import AddProd from "../../assets/images/icons/white_add_prod.png";
import Facebook from "../../assets/images/icons/facebook.svg";
import Whatsapp from "../../assets/images/icons/whatsapp.svg";
import ShowPriceMarker from "../../components/leaflet/markers/ShowPriceMarker";
import { connect } from "react-redux";
import actions from "../../redux/groceryList/action";
import { isMobile, isIOS } from "react-device-detect";
import { NotificationManager } from "react-notifications";
import { serverResponse } from "../../util/fakeServer";
import { strings } from "../../util/data/strings";
import { gaEventLabel } from "../../settings/gaConfig";
import { styles } from "./product.style";
import { language } from "../../languageProvider/language/language";
import { defaultLanguage, sendAnalyticsEvent } from "../../helper/utility";
import VideoInteractivity from "../leaflet/videoInteractivity/VideoInteractivity";
import Marker from "../leaflet/markers/Marker";
import TitleModal from "../modal/modalbody/components/Title.modal";
import TextModal from "../modal/modalbody/components/Text.modal";
import GalleryModal from "../modal/modalbody/components/Gallery.modal";
import Price from "../modal/modalbody/components/Price.modal";

const productUrl = serverResponse.config.shareFlyerURL;

class ProductDefault extends Component {
  state = {
    itemCarousel: 0,
    varietySelected: this.props.info.varieties
      ? this.props.info.varieties[0]
      : "",
    saveTooltipOpen: false,
    tooltipPricesOpen: false
  };

  componentWillReceiveProps(props) {
    this.setState({
      quantity: props.info.quantity_step ? props.info.quantity_step : 1,
      varietySelected: props.info.varieties ? props.info.varieties[0] : ""
    });
  }

  componentDidMount() {
    this.setState({
      quantity: this.props.info.quantity_step
        ? this.props.info.quantity_step
        : 1
    });
  }

  navMarkers = (newMarker) => {
    var element = document.getElementById(
      newMarker + "-" + this.props.info.item_id
    );
    element.click();
  };

  incrementQty = () => {
    this.setState({
      quantity:
        this.state.quantity +
        (this.props.info.quantity_step ? this.props.info.quantity_step : 1)
    });
  };

  decrementQty = () => {
    if (this.props.info.quantity_step) {
      if (this.state.quantity > this.props.info.quantity_step) {
        this.setState({
          quantity: this.state.quantity - this.props.info.quantity_step
        });
      }
    } else if (this.state.quantity > 1) {
      this.setState({ quantity: this.state.quantity - 1 });
    }
  };

  shareOnFacebook = () => {
    sendAnalyticsEvent(
      gaEventLabel.share_product_facebook,
      String(this.props.info.item_id)
    );
    let fb_share_url = "https://www.facebook.com/share.php?u=";
    let page_url =
      productUrl + "/share/product.php?c=" + this.props.info.item_id;
    window.open(
      fb_share_url + encodeURIComponent(page_url),
      "_blank",
      "location=yes,height=570,width=520,scrollbars=yes,status=yes"
    );
  };

  shareOnWhatsapp = () => {
    sendAnalyticsEvent(
      gaEventLabel.share_product_whatsapp,
      String(this.props.info.item_id)
    );
    let page_url =
      productUrl + "/share/product.php?c=" + this.props.info.item_id;
    if (window.ReactNativeWebView !== undefined && isIOS) {
      let link = encodeURIComponent(page_url);
      let title = serverResponse.config.shareProductSentence;
      var str = title + " " + link;
      var obj = { action: "whatsapp", value: str };
      window.ReactNativeWebView.postMessage(JSON.stringify(obj));
    } else {
      window.open(
        "http://api.whatsapp.com/send?text=" +
          serverResponse.config.shareProductSentence +
          " " +
          encodeURIComponent(page_url),
        "_blank",
        "location=yes,height=570,width=520,scrollbars=yes,status=yes"
      );
    }
  };

  handleAddProduct = () => {
    let obj = Object.assign({}, this.props.info);
    obj.quantity = this.state.quantity;
    obj.done = false;
    obj.variety = this.state.varietySelected;
    this.props.addProduct(obj);
    NotificationManager.success(
      language[defaultLanguage].controlla_la_tua_lista_della_spesa,
      language[defaultLanguage].prodotto_aggiunto,
      800
    );

    sendAnalyticsEvent(
      gaEventLabel.add_to_grocery_list,
      String(this.props.info.item_id)
    );
    sendAnalyticsEvent(
      gaEventLabel.open_product,
      String(this.props.info.item_id)
    );
  };

  handleChangeVariety = (e) => {
    this.setState({
      varietySelected: e.target.value
    });
  };

  toggleSaveTooltip = () => {
    this.setState({ saveTooltipOpen: !this.state.saveTooltipOpen });
  };

  toggleTooltipPricesOpen = () => {
    this.setState({ tooltipPricesOpen: !this.state.tooltipPricesOpen });
  };

  render() {
    const { info } = this.props;

    let markers = this.props.info.markers.map((element, index) => {
      if (
        this.props.info.type === "video" &&
        !this.props.info.markers[0].data.open_modal
      ) {
        return (
          <VideoInteractivity
            key={index}
            info={this.props.info}
            markerInfo={element}
            leafletSwipe={this.props.leafletSwipe}
            type={element.type}
          />
        );
      }
      return (
        <Marker
          // zoom={this.props.zoom}
          // disableSwipe={this.props.disableSwipe}
          // enableSwipe={this.props.enableSwipe}
          key={index}
          info={this.props.info}
          markerInfo={element}
          leafletSwipe={this.props.leafletSwipe}
          // navMarkers={this.navMarkers}
          // setSwipe={this.props.setSwipe}
          // isSwipeDisabed={this.props.isSwipeDisabed}
          type={element.type}
        />
      );
    });

    const stock = {
      y: {
        text: "Disponibile",
        color: "green",
        icon: <i className="fas fa-check"></i>
      },
      n: {
        text:
          "Non disponibile" +
          (this.props.info.tdc !== null
            ? " - arrivo tra " + this.props.info.tdc + " giorni"
            : ""),
        color: "red",
        icon: <i className="fas fa-times"></i>
      },
      c: {
        text: this.props.info.available_from,
        color: "var(--secondary-color)",
        icon: <i className="far fa-clock"></i>
      }
    };

    var disp = stock[this.props.info.stock];

    // eslint-disable-next-line no-unused-vars
    let hidden_price_marker = [];
    if (this.props.info.hidden_price) {
      hidden_price_marker = this.props.info.markers.map((element, key) => {
        switch (element.type) {
          case "play": {
            return (
              <ShowPriceMarker
                showButton={true}
                key={key + 10}
                info={info}
                markerInfo={element}
                leafletSwipe={() => {}}
                navMarkers={this.navMarkers}
                setSwipe={() => {}}
              />
            );
          }
          default:
            return null;
        }
      });
    }

    let varieties = <Row className="varieties-container"></Row>;
    if (this.props.info.varieties.length > 1) {
      if (this.props.info.varieties.length > 0) {
        varieties = (
          <Row style={{ minHeight: "0px", marginBottom: "15px" }}>
            <Col md="12">
              {/* <Label for="variety">Scegli:</Label>*/}
              <InputGroup>
                {/*    <InputGroupAddon addonType="prepend"><span className="input-group-text icon-input-group"><FontAwesomeIcon icon={faBars} /></span></InputGroupAddon>*/}
                <InputGroupAddon addonType="prepend"></InputGroupAddon>
                <Input
                  style={{ borderRadius: "6px" }}
                  type="select"
                  name="select"
                  id="variety"
                  value={this.state.varietySelected}
                  onChange={this.handleChangeVariety}
                >
                  {this.props.info.varieties.map((element, key) => {
                    return (
                      <option key={key} value={element}>
                        {element}
                      </option>
                    );
                  })}
                </Input>
              </InputGroup>
            </Col>
          </Row>
        );
      }
    }

    let brandImg = "";
    if (
      serverResponse.config.brandImage !== "" &&
      this.props.info.pam === true
    ) {
      brandImg = (
        <img
          style={{ width: "30%" }}
          src={serverResponse.config.brandImage}
          alt="img"
        />
      );
    }

    let cardImg = "";
    if (
      serverResponse.config.underPriceImage !== "" &&
      serverResponse.config.underPriceImage !== null &&
      this.props.info.underpriced_product === true
    ) {
      cardImg = (
        <img
          style={{ width: "50%", marginTop: "10px" }}
          src={serverResponse.config.underPriceImage}
          alt="img"
        />
      );
    }

    let h6Class = "";
    let isLineThrough = false;
    if (Boolean(serverResponse.config.line_through) === true) {
      h6Class = "barrato";
      isLineThrough = true;
    }

    return (
      <div className="ptb-15">
        <div className="roe-card-style">
          <div
            className="roe-card-header custom-card-header"
            style={{ paddingTop: "10px", paddingBottom: "10px" }}
          >
            {/* markers e condivisione */}
            <div className="row">
              <div className="col-12">
                <div className="markers-container markers-container-no-margin">
                  {markers}

                  {this.props.info.stock !== null &&
                    this.props.info.stock !== undefined &&
                    serverResponse.config.manager_stock && (
                      <span style={styles.available(disp.color, isMobile)}>
                        {disp.icon} {disp.text}
                      </span>
                    )}
                  {!serverResponse.config.hide_share_product && (
                    <img
                      src={Facebook}
                      className="share-icon"
                      style={{ marginLeft: "auto" }}
                      alt="facebook"
                      onClick={() => this.shareOnFacebook()}
                    />
                  )}
                  {!serverResponse.config.hide_share_product && (
                    <img
                      src={Whatsapp}
                      className="share-icon"
                      alt="whatsapp"
                      onClick={() => this.shareOnWhatsapp()}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="roe-card-body">
            <div className="row">
              <div className="col-12 container-fields">
                {/* Testi */}
                <TitleModal title={info.field1} />
                <TextModal text1={info.field2} varieties={info.varieties} />
                <TextModal text1={info.field3} text2={info.field4} />
                {brandImg}
                {cardImg}
              </div>
              <div className="col-12">
                <GalleryModal gallery={info.images} />
              </div>
              <div className="col-12">
                <Price {...info} />
              </div>
            </div>
            <Row style={{ justifyContent: "space-between", marginTop: "10px" }}>
              <Col
                className={
                  info.focus || info.one_and_one_gratis ? "col-12" : "col-6"
                }
                md={info.focus || info.one_and_one_gratis ? 12 : 6}
                lg={info.focus || info.one_and_one_gratis ? 12 : 8}
                style={{ minHeight: "140px" }}
              >
                <div className="product-price">
                  {isLineThrough && info.field4 !== "" && (
                    <div className={h6Class} style={{ fontSize: "14px" }}>
                      {info.field4}
                    </div>
                  )}
                  {isLineThrough && info.field4 === "" && (
                    <div style={{ fontSize: "14px" }}>&nbsp;</div>
                  )}
                  {info.offer_price !== null && (
                    <span
                      className="barrato mr-3"
                      style={{ fontSize: "15px", color: "grey" }}
                    >
                      &euro;{info.price.replace(".", ",")}
                    </span>
                  )}
                </div>
                <div>{varieties}</div>
                {!info.focus &&
                  !info.one_and_one_gratis &&
                  !serverResponse.config.hide_grocery_list && (
                    <div
                      className="container-add-to-list container-add-to-list-color"
                      style={{
                        borderRadius: "6px",
                        visibility: this.props.info.hidden_price ? "hidden" : ""
                      }}
                    >
                      <FontAwesomeIcon
                        className="change-product-quantity-icon"
                        icon={faMinusCircle}
                        onClick={() => this.decrementQty()}
                      />
                      <h6>
                        {this.state.quantity}{" "}
                        <span style={{ fontWeight: "bold" }}>
                          {info.grocery_label}
                        </span>
                      </h6>
                      <FontAwesomeIcon
                        className="change-product-quantity-icon"
                        icon={faPlusCircle}
                        onClick={() => this.incrementQty()}
                      />
                    </div>
                  )}
              </Col>
              {!info.focus &&
                !info.one_and_one_gratis &&
                !serverResponse.config.send_grocery_list_to_market &&
                !serverResponse.config.hide_grocery_list && (
                  <Col
                    className="col-6 align-self-center"
                    md={{ size: 4, offset: 2 }}
                    lg={{ size: 4, offset: 0 }}
                  >
                    <div
                      className=""
                      style={{
                        justifyContent: "flex-end",
                        textAlign: "center"
                      }}
                    >
                      <Button
                        disabled={
                          this.props.info.stock !== "y" &&
                          this.props.info.stock !== undefined &&
                          this.props.info.stock !== null
                        }
                        className="button-send-to-cart"
                        id={"btnSave_" + info.item_id}
                        color="primary"
                        onClick={this.handleAddProduct}
                      >
                        {
                          <img
                            src={AddProd}
                            style={{
                              color: "#00ff00",
                              width: "30px",
                              cursor: "pointer"
                            }}
                            alt="img"
                          />
                        }
                      </Button>
                      {!isMobile &&
                        (this.props.info.stock === "y" ||
                          this.props.info.stock === undefined) && (
                          <Tooltip
                            placement="top"
                            isOpen={this.state.saveTooltipOpen}
                            target={"btnSave_" + info.item_id}
                            toggle={this.toggleSaveTooltip}
                          >
                            {strings.saveBtnTooltip}
                          </Tooltip>
                        )}
                    </div>
                  </Col>
                )}
              {!info.focus &&
                !info.one_and_one_gratis &&
                serverResponse.config.send_grocery_list_to_market &&
                !serverResponse.config.hide_grocery_list && (
                  <Col
                    className="col-6 align-self-center"
                    md={{ size: 4, offset: 2 }}
                    lg={{ size: 4, offset: 0 }}
                  >
                    <div
                      className=""
                      style={{
                        justifyContent: "flex-end",
                        textAlign: "center"
                      }}
                    >
                      <Button
                        className="button-send-to-cart"
                        id={"btnSave_" + info.item_id}
                        color="primary"
                        onClick={this.handleAddProduct}
                      >
                        <FontAwesomeIcon
                          icon={faShoppingCart}
                          style={{ fontSize: "35px" }}
                        />
                        {/*<img src={AddProd} style={{ color: "#00ff00", width: "30px", cursor: "pointer" }} alt="img" />*/}
                      </Button>
                      {!isMobile && (
                        <Tooltip
                          placement="top"
                          isOpen={this.state.saveTooltipOpen}
                          target={"btnSave_" + info.item_id}
                          toggle={this.toggleSaveTooltip}
                        >
                          {strings.saveBtnTooltip}
                        </Tooltip>
                      )}
                    </div>
                  </Col>
                )}
            </Row>
            <Row
              style={{
                visibility: this.props.info.hidden_price ? "hidden" : ""
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "100%"
                }}
              ></div>
            </Row>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    addProduct: (newProduct) => {
      dispatch(actions.addProduct(newProduct));
    }
  };
}

export default connect(null, mapDispatchToProps)(ProductDefault);
